import React, {Component} from 'react';
import Main from '../../components/smart/Main';
import FloatContainer from '../../components/dummy/FloatContainer';
import VisionReimbursementForm from './../../utils/Forms/VisionReimbursementForm.pdf';
import HIPAAForm from './../../utils/Forms/HIPAA_Notice_01-2015.pdf';
import PrivacyPolicy from './../../utils/Forms/Internet_Privacy_Policy_01-2015.pdf';
import BrokerZip from './../../utils/Forms/BrokerZip.zip';

class FormsPage extends Component {
    render() {
        return(
                <Main Title="Forms & Resources" Description="All in one place">
                <FloatContainer>
                    <div className="Float_Content_Centered">
                        <ul className="Float_List">
                            <h3>For Members</h3>
                            <li><a href={VisionReimbursementForm} rel="noopener noreferrer" target="_blank">Vision Reimbursement Form</a></li>
                        </ul>
                    </div>
                    <div className="Float_Content_Centered">
                        <ul className="Float_List">
                            <h3>For Brokers</h3>
                            <li><a href={BrokerZip} rel="noopener noreferrer" target="_blank">Broker Appointment Forms</a></li>
                            <li><a href="/Quote" target="_blank" rel="noopener noreferrer">Quoting Requirements</a></li>
                        </ul>
                    </div>
                    <div className="Float_Content_Centered">
                        <ul className="Float_List">
                            <h3>Miscellaneous</h3>
                            <li><a href={HIPAAForm} rel="noopener noreferrer" target="_blank">Partner HIPAA Notice</a></li>
                            <li><a href={PrivacyPolicy} rel="noopener noreferrer" target="_blank">Partner Privacy Policy</a></li>
                        </ul>
                    </div>
                </FloatContainer>
                </Main>
        )
    }
};

export default FormsPage;